import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SOILGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SoilGroup.Name')
    .required()
    .minLength(1)
    .maxLength(200)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SoilGroup.Code')
    .required()
    .minLength(1)
    .maxLength(6)
    .build(),
];

export const SOILGROUP_CONFIG = {
  entityName: 'SoilGroup',
  localizationKey: 'Planning::Entity.SoilGroup',
  fields: SOILGROUP_FIELDS,
  permission: 'PlanningGeography.SoilGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Geography + MENU_NAME_SUFFIX,
};
